import * as Yup from "yup";

export const WorkOrderSchema = Yup.object().shape({
  technicianIdentity: Yup.number().nullable(),
  locationIdentity: Yup.number().required("Location field is required"),
  salesPersonIdentity: Yup.number().required("Sales person field is required"),
  salesPersonName: Yup.string().nullable(),
  woStatusIdentity: Yup.number().required(
    "Work order status field is required"
  ),
  woPriorityIdentity: Yup.number().required(
    "Work order priority field is required"
  ),
  purchaseOrderNumber: Yup.string().nullable(),
  woDescription: Yup.string().nullable(),
  woDisplayText: Yup.string().default("").max(15, "Only 15 characters allowed"),
  hoursClocked: Yup.number().nullable(),
  warrantyDate: Yup.date().nullable(),
  woDeliveryDate: Yup.date().nullable(),
  woPickupDate: Yup.date().nullable(),
  model: Yup.string().nullable(),

  woUnitBaseSerial: Yup.string().nullable(),
  woUnitTag: Yup.string().nullable(),
  woUnitDescription: Yup.string().nullable(),
  woUnitIsAttachment: Yup.boolean().default(false),
  woUnitIsNew: Yup.boolean().default(false),
  WOUnitNoSearchType: Yup.string().nullable(),

  customerIdentity: Yup.number().required("Customer field is required"),
  customerName: Yup.string().nullable(),
  woUnitIdentity: Yup.number().nullable(),
  meterType: Yup.string().nullable(),
  stockNumber: Yup.string().nullable(),
  documentNumber: Yup.string().nullable(),
  nonPrintedComment: Yup.string().nullable(),
  //WO Schedule
  scheduleStartTime: Yup.date().nullable(),
  scheduleEndTime: Yup.date().nullable(),

  meterValue: Yup.number()
    .default(0) // Set default to 0
    .transform((value, originalValue) => {
      return originalValue === "" ? 0 : value; // Convert empty string to 0
    })
    .test(
      "meter-value-validation",
      "Stock Number and Meter Type are required when Meter Value is greater than 0",
      function (value) {
        //
        const { stockNumber, meterType } = this.parent;
        if (value > 0 && (!stockNumber || !meterType)) {
          return false; // Trigger validation error
        }
        return true;
      }
    ),
  segments: Yup.array().of(
    Yup.object().shape({
      displayText: Yup.string()
        .min(1)
        .max(15)
        .required("Display text is required"),
      serviceCodeIdentity: Yup.string()
        .min(1)
        .max(4000)
        .required("Display text is required"),
    })
  ),
});
